import React, { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import CardScoringSettings from "./CardScoringSettings";
import SuccessAlert from "../helpers/successAlert";

// Standalone page wrapper for the card-scoring configuration. Holds the config
// state, renders the (reused) slider + live-preview UI, and persists to its own
// dedicated endpoint so it stays independent of the dense main settings page.
const CardScoringPage = ({ initialConfig, seasons, t_controls }) => {
  const t = t_controls.card_scoring || {};
  const [cardScoring, setCardScoring] = useState(initialConfig || {});
  const [isLoading, setIsLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSave = () => {
    const locale = window.location.pathname.split("/")[1];
    const token = document.querySelector("[name=csrf-token]").content;

    setIsLoading(true);
    setAlertMessage("");
    setErrorMessage("");

    const formData = new FormData();
    formData.append("card_scoring", JSON.stringify(cardScoring));

    axios
      .patch(`/${locale}/settings/card_scoring`, formData, {
        headers: { "X-CSRF-TOKEN": token, "Content-Type": "multipart/form-data" },
      })
      .then(() => {
        setIsLoading(false);
        setAlertMessage(t_controls.updated || "Successfully updated");
      })
      .catch(() => {
        setIsLoading(false);
        setErrorMessage(t.save_error || "Could not save. Please try again.");
      });
  };

  return (
    <div className="container mt-2">
      {alertMessage && <SuccessAlert message={alertMessage} />}
      {errorMessage && <span style={{ color: "#dc3545" }}>{errorMessage}</span>}

      <CardScoringSettings
        cardScoring={cardScoring}
        setCardScoring={setCardScoring}
        seasons={seasons || []}
        t_controls={t_controls}
      />

      <div className="form-buttons mt-3">
        <button className="btn btn-primary" disabled={isLoading} onClick={handleSave}>
          {isLoading ? (t_controls.saving || "Saving...") : (t_controls.save || "Save")}
        </button>
      </div>
    </div>
  );
};

CardScoringPage.propTypes = {
  initialConfig: PropTypes.object,
  seasons: PropTypes.array,
  t_controls: PropTypes.object.isRequired,
};

export default CardScoringPage;
